import { AdminLayout } from "@/components/shared/AdminLayout";
import { HISTORY_REPORTS, ReportHistory } from "@/components/verizon/ReportHistory";

export default function AdminReportHistory({ report }) {
  const name = `${HISTORY_REPORTS[report].name} History`;
  return (
    <AdminLayout title={name} breadcrumb={`Reports / ${name}`}>
      <ReportHistory mode="admin" report={report} key={report} />
    </AdminLayout>
  );
}
